import * as React from "react";
import { IconProps } from "./IconProps";

export const IconSearch = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 2.5C3.84315 2.5 2.5 3.84315 2.5 5.5C2.5 7.15685 3.84315 8.5 5.5 8.5C7.15685 8.5 8.5 7.15685 8.5 5.5C8.5 3.84315 7.15685 2.5 5.5 2.5ZM1.5 5.5C1.5 3.29086 3.29086 1.5 5.5 1.5C7.70914 1.5 9.5 3.29086 9.5 5.5C9.5 6.42436 9.18646 7.27548 8.65993 7.95282L10.3535 9.64644C10.5488 9.8417 10.5488 10.1583 10.3535 10.3535C10.1583 10.5488 9.8417 10.5488 9.64644 10.3535L7.95282 8.65993C7.27548 9.18646 6.42436 9.5 5.5 9.5C3.29086 9.5 1.5 7.70914 1.5 5.5Z"
          fill={color}
        />
      </svg>
    );
  },
);
